import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import _ from "lodash";
import LeftSideBar from "./LeftSideBar";
import SocialLogin from "../../SocialLogin";
import RegisterForm from "./RegisterForm";
import { Wrapper, RightSide, LoginBox } from "../styles";
import { getStatusServer } from "../../../utils/functions";
import LitOnlearning from "../../../images/lit.png";
import LogoPlanos from "../../../images/sp_lit.png";

const TextH3Header = styled.h4`
  color: #02c4fd;
  margin-bottom: 0;
  text-align: justify;
  width: 100%;
`;
const TextH4Header = styled.h4`
  color: #02c4fd;
  margin-bottom: 0;
  text-align: center;
  width: 100%;
`;

const LinkLogin = styled(Link)`
  color: #02c4fd;
  text-decoration: underline;
`;

const MobileHeader = styled.nav`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    width: 100%;
    background: #27aae1; /* Cor padrão do LIT */
    
    .navbar-brand {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      
      img {
        max-width: 120px;
        height: auto;
        max-height: 50px;
        object-fit: contain;
      }
    }
  }
`;

export default function LIT({
  handleRegisterSuccess,
  handleRegisterFailure,
  handleSocialSuccess,
  handleSocialFailure,
  userDetails,
  promo,
  origin,
  litpass,
  isVocacao
}) {

  const [goToLoginURL, setGoToLoginURL] = useState('');
  const [tenantSettings, setTenantSettings] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // getStatusServer();
    let url = '/';
    const loginTenant = localStorage.getItem('loginTenant');

    if(litpass){
      url+=`litpass/`
    } else if(isVocacao){
      url+=`vocacao/`
    }

    if(loginTenant){
      url+=`${loginTenant.toLowerCase()}`
    }

    if(origin && origin !== "default"){
      url+=`?o=${origin}`
    }

    setGoToLoginURL(url);
  }, []);

  useEffect(() => {
    // Verificar se é mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Buscar configurações do tenant
    const getTenantSettings = () => {
      // Primeiro tenta pegar do domainSettings (usado no cadastro)
      const domainSettings = localStorage.getItem('domainSettings');
      if (domainSettings) {
        try {
          const parsed = JSON.parse(domainSettings);
          setTenantSettings(parsed);
          return;
        } catch (e) {
          console.error('Error parsing domainSettings', e);
        }
      }
      
      // Se não encontrar, tenta pegar do settings (usado no NavBarSuperior)
      const settings = localStorage.getItem('settings');
      const tenant = localStorage.getItem('loginTenant') || localStorage.getItem('tenant');
      
      if (settings && tenant) {
        try {
          const parsed = JSON.parse(settings);
          const tenantConfig = parsed[tenant];
          if (tenantConfig) {
            setTenantSettings(tenantConfig);
            return;
          }
        } catch (e) {
          console.error('Error parsing settings', e);
        }
      }
      
      // Se não encontrar nada, deixa null para usar padrão
      setTenantSettings(null);
    };
    
    getTenantSettings();
  }, []);

  // Obter logo do tenant ou usar padrão (mesma logo da tela de planos)
  const getLogo = () => {
    if (tenantSettings && tenantSettings.logoUrl) {
      return tenantSettings.logoUrl;
    }
    return LogoPlanos;
  };

  // Obter cor de background do tenant ou usar padrão
  const getBackgroundColor = () => {
    if (tenantSettings) {
      return tenantSettings.headerBackgroundColor || 
             tenantSettings.primaryBackgroundColor || 
             '#27aae1';
    }
    return '#27aae1'; // Cor padrão do LIT
  };

  return (
    <>
      {isMobile && (
        <MobileHeader 
          className="navbar navbar-lit navbar-expand-lg p-2"
          style={{ background: getBackgroundColor() }}
        >
          <a className="navbar-brand">
            <img src={getLogo()} alt="Logo" />
          </a>
        </MobileHeader>
      )}
      <div className="row">
        <LeftSideBar
        promo={promo}
        origin={origin}
        litpass={litpass}
        isVocacao={isVocacao}
      />
      <RightSide className="col-md-5">
        <LoginBox origin={origin}>
          {litpass && (
            <TextH3Header>
              Inscreva-se agora com seu e-mail corporativo
            </TextH3Header>
          )}
          {isVocacao && (
            <TextH3Header>
              Inscreva-se agora com seu e-mail corporativo
            </TextH3Header>
          )}
          {!litpass && !isVocacao && (
            <TextH4Header>Inscreva-se agora</TextH4Header>
          )}

          <Wrapper>
            <div className="criar-conta">
              <p>
                Já é aluno?{" "}
                <LinkLogin to={goToLoginURL}>Faça seu login.</LinkLogin>
              </p>
            </div>
            <RegisterForm
              userDetails={userDetails}
              litpass={litpass}
              isVocacao={isVocacao}
              doRegisterSuccess={handleRegisterSuccess}
              doRegisterFailure={handleRegisterFailure}
            />
          </Wrapper>
          {!litpass && !isVocacao && (
            <div className="mt-1 align-self-center mt-4">
              <p>Ou faça login pelas redes sociais </p>
              <SocialLogin
                handleSocialLogin={handleSocialSuccess}
                handleSocialError={handleSocialFailure}
              />
            </div>
          )}
        </LoginBox>
      </RightSide>
      </div>
    </>
  );
}
